import React from 'react';

/**
 * Loading skeleton for Lander3Page
 * Matches the layout structure for instant visual feedback while JS loads
 */
const Lander3Skeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg relative">
      {/* Background overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0D10] via-[#0B0D10]/95 to-[#0B0D10] opacity-50 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Badge skeleton */}
        <div className="flex justify-center lg:justify-start mb-6">
          <div className="h-8 w-56 bg-white/10 rounded-full animate-pulse" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column */}
          <div className="space-y-6 text-center lg:text-left">
            {/* Headline */}
            <div className="space-y-3">
              <div className="h-10 sm:h-14 bg-white/10 rounded-lg w-4/5 mx-auto lg:mx-0 animate-pulse" />
              <div className="h-10 sm:h-14 bg-white/10 rounded-lg w-3/5 mx-auto lg:mx-0 animate-pulse" />
            </div>
            {/* Subtitle */}
            <div className="h-5 bg-white/10 rounded w-3/4 mx-auto lg:mx-0 animate-pulse" />

            {/* Mobile: example images skeleton */}
            <div className="flex gap-3 justify-center lg:hidden">
              <div className="w-40 h-52 bg-white/10 rounded-2xl animate-pulse" />
              <div className="w-40 h-52 bg-white/10 rounded-2xl animate-pulse" />
            </div>

            {/* Trust badges skeleton */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-4">
              <div className="h-4 w-36 bg-white/10 rounded animate-pulse" />
              <div className="h-4 w-40 bg-white/10 rounded animate-pulse" />
              <div className="h-4 w-44 bg-white/10 rounded animate-pulse" />
            </div>

            {/* Upload box skeleton */}
            <div className="border-2 border-dashed border-white/30 rounded-xl p-12 bg-white/5">
              <div className="flex flex-col items-center space-y-4">
                <div className="w-16 h-16 bg-white/10 rounded-full animate-pulse" />
                <div className="h-6 bg-white/10 rounded w-48 animate-pulse" />
                <div className="h-4 bg-white/10 rounded w-64 animate-pulse" />
              </div>
            </div>
          </div>

          {/* Right Column - Desktop examples skeleton */}
          <div className="hidden lg:grid grid-cols-2 gap-6">
            <div className="flex flex-col items-center">
              <div className="w-36 h-36 rounded-2xl bg-white/10 animate-pulse mb-4" />
              <div className="w-6 h-6 bg-white/10 rounded-full animate-pulse my-3" />
              <div className="w-full h-80 rounded-2xl bg-white/10 animate-pulse" />
            </div>
            <div className="flex flex-col items-center">
              <div className="w-36 h-36 rounded-2xl bg-white/10 animate-pulse mb-4" />
              <div className="w-6 h-6 bg-white/10 rounded-full animate-pulse my-3" />
              <div className="w-full h-80 rounded-2xl bg-white/10 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lander3Skeleton;
